import { INIT_DEDUCTIBLES, UNSET_DEDUCTIBLES} from './actions';

export const initialState = () => {
    return {
        id: null,
        zipcodes: null,
    };
};

const deductibles = (state = initialState(), action) => {
    const { type, payload } = action;

    switch (type) {
        case INIT_DEDUCTIBLES:
            return { ...state, ...payload };
        case UNSET_DEDUCTIBLES:
            return initialState()
        default:
            return state;
    }
};

export default deductibles;
